import { render, staticRenderFns } from "./AxisX.vue?vue&type=template&id=ab6a342c&scoped=true&"
import script from "./AxisX.vue?vue&type=script&lang=js&"
export * from "./AxisX.vue?vue&type=script&lang=js&"
import style0 from "./AxisX.vue?vue&type=style&index=0&id=ab6a342c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6a342c",
  null
  
)

export default component.exports